<template>
    <section class="app-main">
        <router-view v-slot="{ Component }">
            <transition name="fade-transform" mode="out-in">
                <component :is="Component" />
            </transition>
        </router-view>
    </section>
</template>

<script>
import { computed } from 'vue';
import { useRoute } from 'vue-router';
export default {
    name: 'AppMain',
    setup() {
        const route = useRoute();
        return {
            key: computed(() => route.path)
        };
    }
};
</script>

<style lang="scss" scoped>
.app-main {
    /* 50= navbar  50  */
    min-height: calc(100vh - 104px);
    margin: 84px 20px 20px 20px;
    background-color: #ffffff;
    padding: 20px;
    overflow: hidden;
}
</style>
